module.exports = __webpack_public_path__ + "img/g11.73f154ef.jpg";